var map = {
	"./": 212,
	"./Clutch": 486,
	"./Clutch/": 486,
	"./Clutch/index": 486,
	"./Clutch/index.js": 486,
	"./Clutch/style": 1131,
	"./Clutch/style.js": 1131,
	"./NewUi": 487,
	"./NewUi/": 487,
	"./NewUi/index": 487,
	"./NewUi/index.js": 487,
	"./NewUi/style": 1132,
	"./NewUi/style.js": 1132,
	"./OldUi": 488,
	"./OldUi/": 488,
	"./OldUi/index": 488,
	"./OldUi/index.js": 488,
	"./OldUi/style": 1133,
	"./OldUi/style.js": 1133,
	"./SpireonNew": 489,
	"./SpireonNew/": 489,
	"./SpireonNew/index": 489,
	"./SpireonNew/index.js": 489,
	"./SpireonNew/style": 1134,
	"./SpireonNew/style.js": 1134,
	"./SpireonOld": 490,
	"./SpireonOld/": 490,
	"./SpireonOld/index": 490,
	"./SpireonOld/index.js": 490,
	"./SpireonOld/style": 1135,
	"./SpireonOld/style.js": 1135,
	"./index": 212,
	"./index.js": 212,
	"./style": 224,
	"./style.js": 224
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 4213;
module.exports = webpackAsyncContext;